// Dark Music Theme Color Palette for MusiLinks
// Purple/Pink/Cyan music-inspired design system

const palette = {
  // Primary brand colors (purple/pink gradient)
  primary: {
    lightest: '#CE93D8',
    lighter: '#BA68C8',
    light: '#AB47BC',
    main: '#9C27B0',
    dark: '#7B1FA2',
    darker: '#6A1B9A',
    darkest: '#4A148C',
    gradient: 'linear-gradient(135deg, #9C27B0 0%, #E91E63 50%, #00BCD4 100%)',
    gradientHover: 'linear-gradient(135deg, #7B1FA2 0%, #C2185B 50%, #0097A7 100%)',
    contrastText: '#FFFFFF',
  },

  // Secondary colors
  secondary: {
    lightest: '#475569',
    lighter: '#334155',
    light: '#1A1F35',
    main: '#0A0E1A',
    dark: '#070B14',
    darker: '#05080F',
    darkest: '#030509',
    contrastText: '#F1F5F9',
  },

  // Accent colors
  accent: {
    purple: '#9C27B0',
    pink: '#E91E63',
    cyan: '#00BCD4',
    blue: '#2196F3',
    amber: '#FFA726',
    lime: '#66BB6A',
    coral: '#FF6B6B',
  },

  success: {
    main: '#66BB6A',
    light: '#81C784',
    dark: '#4CAF50',
    contrastText: '#FFFFFF',
  },

  error: {
    main: '#FF6B6B',
    light: '#FF8A80',
    dark: '#E53935',
    contrastText: '#FFFFFF',
  },

  warning: {
    main: '#FFA726',
    light: '#FFB74D',
    dark: '#F57C00',
    contrastText: '#FFFFFF',
  },

  info: {
    main: '#00BCD4',
    light: '#4DD0E1',
    dark: '#0097A7',
    contrastText: '#FFFFFF',
  },

  // Dark theme backgrounds
  background: {
    default: '#0A0E1A',
    paper: '#141828',
    elevated: '#1A1F35',
    subtle: '#111525',
    overlay: 'rgba(10, 14, 26, 0.8)',
    glass: 'rgba(20, 24, 40, 0.5)',
  },

  // Text colors
  text: {
    primary: '#F1F5F9',
    secondary: '#E2E8F0',
    muted: '#94A3B8',
    disabled: '#64748B',
    hint: '#475569',
  },

  // Borders and dividers
  divider: 'rgba(255, 255, 255, 0.06)',
  border: {
    default: 'rgba(255, 255, 255, 0.06)',
    light: 'rgba(255, 255, 255, 0.08)',
    focus: 'rgba(156, 39, 176, 0.5)',
  },

  common: {
    black: '#000000',
    white: '#FFFFFF',
  },

  // Gray scale
  grey: {
    50: '#F8FAFC',
    100: '#F1F5F9',
    200: '#E2E8F0',
    300: '#CBD5E1',
    400: '#94A3B8',
    500: '#64748B',
    600: '#475569',
    700: '#334155',
    800: '#1E293B',
    900: '#0F172A',
  },

  // Glassmorphism effects
  glass: {
    background: 'rgba(20, 24, 40, 0.5)',
    border: 'rgba(255, 255, 255, 0.08)',
    shadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
    blur: 'blur(20px)',
  },
};

export default palette;
